import { useParams } from 'react-router-dom';
import { useDealStatusHistoryQuery } from '../../shared/hooks';
import React from 'react';
import { CerebroDrawer, CerebroHeading } from '../../shared/components';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Skeleton } from '@mui/material';
import { DateUtils, EnumUtils } from '../../shared/utils';
import { DealStatusStat } from '../../shared/models';

interface StatusHistoryDrawerProps {
	open?: boolean;
	onClose: () => void;
}

export const StatusHistoryDrawer: React.FC<StatusHistoryDrawerProps> = ({ open, onClose }) => {
	const { guid } = useParams<'guid'>();
	var query = useDealStatusHistoryQuery(guid);
	const ref = React.useRef<HTMLDivElement>(null);

	return (
		<CerebroDrawer ref={ref} open={open} onClose={onClose}>
			<CerebroHeading>Status History</CerebroHeading>

			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Status</TableCell>
							<TableCell>Started</TableCell>
							<TableCell>Ended</TableCell>
							<TableCell>Updated By</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{query.isLoading && (
							<>
								<TableRow>
									<TableCell colSpan={4}>
										<Skeleton height={60} />
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell colSpan={4}>
										<Skeleton height={60} />
									</TableCell>
								</TableRow>
							</>
						)}
						{query.isSuccess && (
							<>
								{query.data.sort(compareStats).map(history => {
									return (
										<TableRow key={history.id}>
											<TableCell>
												{EnumUtils.GetDealStatusDescription(history.dealStatus)}
											</TableCell>
											<TableCell>
												{DateUtils.FormatStringAsShortDate(history.startDate?.toString())}
											</TableCell>
											<TableCell>
												{history.endDate
													? DateUtils.FormatStringAsShortDate(history.endDate?.toString())
													: 'Current Status'}
											</TableCell>
											<TableCell>{history.updatedBy}</TableCell>
										</TableRow>
									);
								})}
								{query.data.length == 0 && (
									<TableRow>
										<TableCell colSpan={4}>There is no status history for this deal</TableCell>
									</TableRow>
								)}
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</CerebroDrawer>
	);
};

function compareStats(first: DealStatusStat, second: DealStatusStat): number {
	if (first.startDate && second.startDate) {
		if (first.startDate > second.startDate) {
			return -1;
		}

		if (second.startDate > first.startDate) {
			return 1;
		}
	}

	return 0;
}
